import { render, staticRenderFns } from "./CallCheckboxInput.vue?vue&type=template&id=8efc96da&"
import script from "./CallCheckboxInput.vue?vue&type=script&lang=ts&"
export * from "./CallCheckboxInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports